/* CHANGELOG 2026-11-03. Cord via Perplexity Computer.
   HG series buy-area treatment (Intelligems content test / draft preview only).
   Native commerce elements are retained and reordered, never cloned or replaced.
   Rollback: end the HG experiment; live theme 181621031159 unchanged. */
(() => {
  'use strict';
  const CONFIG = {"key":"hg","name":"HG","kicker":"Hooga HG Series","shipping":"Free US shipping","chooseHeading":"Choose your HG","chooseNote":"Different sizes. Same series.","ledNote":"Separate red + NIR switches","seriesSpecs":[["Light","660 + 850 nm","Red + near-infrared"]],"models":[{"handle":"hooga-200","name":"HG200","coverage":"Targeted","leds":"40 single-chip","output":"73 mW/cm²","setup":"Built-in stand","setupDetail":"Session timer","intro":"Compact single-chip red and near-infrared panel for targeted sessions. Built-in tabletop stand and session timer."},{"handle":"hooga-300w-red-and-near-infrared-light-therapy-panel","name":"HG300","coverage":"Targeted","leds":"60 single-chip","output":"73 mW/cm²","setup":"Kickstand built in","setupDetail":"Session timer","intro":"Single-chip red and near-infrared light for targeted sessions, with a fold-out tabletop stand and session timer."},{"handle":"hooga-500w-red-and-near-infrared-light-therapy-panel","name":"HG500","coverage":"Half body","leds":"100 single-chip","output":"94 mW/cm²","setup":"Hanging kit","setupDetail":"Door mount included","intro":"A half-body single-chip panel with separate red and near-infrared switches. Built-in timer; door mount and hanging kit included."},{"handle":"hooga-1000w-red-and-near-infrared-light-therapy-panel","name":"HG1000","coverage":"Slim full body","leds":"200 single-chip","output":"98 mW/cm²","setup":"Hanging kit","setupDetail":"Door mount included","intro":"A narrower full-body single-chip panel with separate red and near-infrared switches. Built-in timer; door mount and hanging kit included."},{"handle":"hg1500-red-light-therapy-device","name":"HG1500","coverage":"Full body","leds":"300 single-chip","output":"115 mW/cm²","setup":"Hanging kit","setupDetail":"Door mount included","intro":"Full-body single-chip coverage with separate red and near-infrared switches. Built-in timer; door mount and hanging kit included."}]};
  const handleOf = p => (p || '').split('?')[0].replace(/\/$/, '').split('/products/')[1] || '';
  const current = CONFIG.models.find(m => m.handle === handleOf(location.pathname));
  if (!current) return;
  const make = (tag, cls, text) => { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; };
  const money = cents => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    const v = cents / 100;
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + v.toLocaleString(); }
  };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function cards() {
    const group = make('div', 'sb-models');
    const head = make('div', 'sb-models-head');
    head.append(make('h2', '', CONFIG.chooseHeading), make('span', '', CONFIG.chooseNote));
    const nav = make('nav', 'sb-model-grid');
    nav.setAttribute('aria-label', CONFIG.chooseHeading);
    nav.style.setProperty('--sb-cols', CONFIG.models.length);
    for (const m of CONFIG.models) {
      const a = make('a', 'sb-model' + (m === current ? ' is-current' : ''));
      a.href = root + 'products/' + m.handle;
      if (m === current) a.setAttribute('aria-current', 'page');
      const price = make('b', 'sb-model-price', '\u00a0');
      a.append(make('strong', '', m.name), make('span', '', m.coverage), price);
      nav.append(a);
      fetch(root + 'products/' + m.handle + '.js', { credentials: 'same-origin' })
        .then(r => r.ok ? r.json() : null)
        .then(p => { if (p && typeof p.price === 'number') price.textContent = money(p.price); })
        .catch(() => {});
    }
    group.append(head, nav);
    return group;
  }

  function specs() {
    const grid = make('dl', 'sb-specs');
    const rows = [...CONFIG.seriesSpecs.slice(0, 1), ['LEDs', current.leds, CONFIG.ledNote], ['Reported irradiance', current.output, 'At 6 inches'], ...CONFIG.seriesSpecs.slice(1), ['Setup', current.setup, current.setupDetail]];
    for (const [label, value, note] of rows) {
      const d = make('div');
      d.append(make('dt', '', label), make('dd', '', value));
      if (note) d.append(make('small', '', note));
      grid.append(d);
    }
    return grid;
  }

  function mount() {
    const info = document.querySelector('product-info.product__info-container');
    const section = info && info.closest('section[id^="MainProduct-"]');
    if (!section) return false;
    if (section.dataset.sbMounted) return true;
    if (handleOf(info.dataset.url) !== current.handle) return true;
    const title = info.querySelector(':scope > .product__title');
    const h1 = title && title.querySelector('h1');
    const cart = info.querySelector(':scope > .btn_withqty_row');
    const price = info.querySelector(':scope > [id^="price-"]');
    if (!h1 || !price || !cart || !cart.querySelector('form[action*="/cart/add"]')) return false;

    // Title: kicker, model name, product-type subtitle (from the native title).
    const full = h1.textContent.trim();
    const rest = full.toUpperCase().startsWith(current.name.toUpperCase()) ? full.slice(current.name.length).trim() : full;
    h1.textContent = current.name;
    if (rest && rest !== current.name) h1.append(make('span', 'sb-sub', rest));
    title.prepend(make('p', 'sb-kicker', CONFIG.kicker));

    // Reviews: move native Yotpo bottom line under the title; show live average.
    const reviews = price.querySelector('.show_yopto_review_box_col');
    if (reviews) {
      reviews.classList.add('sb-reviews');
      title.after(reviews);
      const avg = make('span', 'sb-rating'); avg.hidden = true; reviews.prepend(avg);
      const update = () => {
        const labels = [...reviews.querySelectorAll('[aria-label]')].map(e => e.getAttribute('aria-label')).join(' ');
        const m = labels.match(/(\d(?:\.\d+)?)\s*(?:out\s+(?:of\s+)?|\/\s*)5/i);
        if (m && Number(m[1]) <= 5) { const t = m[1] + '/5'; if (avg.textContent !== t) avg.textContent = t; avg.hidden = false; }
      };
      new MutationObserver(update).observe(reviews, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
      update();
    }

    price.classList.add('sb-price');
    const ship = make('span', 'sb-ship', CONFIG.shipping);
    const intro = make('p', 'sb-intro', current.intro);
    const models = cards();
    const grid = specs();
    info.append(intro, ship, models, grid);

    section.classList.add('sb-series-buy', 'sb-' + CONFIG.key);
    section.dataset.sbMounted = 'true';
    return true;
  }

  const start = () => {
    if (mount()) return;
    const obs = new MutationObserver(() => { if (mount()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 30000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', () => mount());
})();
